import styled from 'styled-components';
import themeColors from 'styles/config/colors';
import themeSpacing from 'styles/config/spacing';

import { ErrorIcon } from 'components/atoms/Icons';
import { CaptionStrong } from 'components/atoms/LegacyText';

export const TooltipWrapper = styled.div`
  display: flex;
`;

export const TooltipIcon = styled(ErrorIcon)`
  cursor: pointer;
`;

export const ErrorWrapper = styled.div<{ $hasIcon?: boolean }>`
  display: flex;
  align-items: ${props => {
    if (props.$hasIcon) {
      return 'center';
    }
    return 'flex-start';
  }};
  gap: ${themeSpacing.xs2};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: 2px;
`;

export const ErrorCaption = styled(CaptionStrong)<{ $hasIcon?: boolean }>`
  margin-bottom: ${props => {
    if (props.$hasIcon) {
      return '0';
    }
    return themeSpacing.xs2;
  }};
  color: ${themeColors.errorText01};
`;
